export default "__VITE_ASSET__7dc186cc__"